module.exports = __webpack_public_path__ + "img/icon-vocabulario.e3f69498.svg";